
















































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import HeadBack from '@/views/competition/components/HeadBack.vue'
import { getAssemblyList, enableOrDisableAssembly,deleteAssembly } from '@/api/assembly'
import { getTitleList } from '@/api/competition'
import { UserModule } from '@/store/modules/user'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'titleManage',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 50
  private tableData = []
  private id = ''
  private status = ''
  private isSearch: boolean = false
  private options =  []
  private titleId = ''
  private titleId1 = ''
  private title = ''
  private largeImageUrl = '' // 放大图片的URL
  private imageDialogVisible = false // 控制模态框的显示

  created() {
    this.title = this.$route.query.title
    this.titleId1 = this.$route.query.titleId
    this.name()
    this.init()
  }

  cancel() {
    this.$router.push({ path: '/competition/two', query: { titleId: this.titleId1, title: this.title } })
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  initProp(val) {
    this.input = val
    this.initFun()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  get userName() {
    return UserModule.username
  }

  private async init(isSearch?: boolean) {
    // if (this.options.length === 0){
    //   const pageParams = {
    //     page: this.page,
    //     pageSize: this.pageSize,
    //     type: 0,
    //   }
    //   await getTitleList(pageParams)
    //     .then((res: any) => {
    //       if (String(res.data.code) === '1') {
    //         this.options = res.data && res.data.data && res.data.data.records
    //         if (this.titleId === '') {
    //         this.titleId = res.data.data.records[0].id
    //         }
    //         // this.counts = res.data.data.total
    //       }
    //       // if (!res.data.data.records.length && type === 'search') {
    //       //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
    //       // }
    //     })
    //     .catch((err) => {
    //       this.$message.error('请求出错了：' + err.message)
    //     })
    //   }
    this.isSearch = isSearch
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      name: this.input ? this.input : undefined,
      type: 1,
      titleId: this.titleId
    }
    await getAssemblyList(params)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.tableData = res.data && res.data.data && res.data.data.records
          this.counts = res.data.data.total
        }
        // if (!res.data.data.records.length && type === 'search') {
        //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
        // }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 显示放大图片
  private showImage(url: string) {
    this.largeImageUrl = url
    this.imageDialogVisible = true
  }

  // 监听 titleId 的变化
  private handleTitleChange() {
    this.init();
  }

  // 添加
  private addEmployeeHandle(st: string, username: string) {
    if (st === 'add') {
      this.$router.push({ path: '/eventIntroductionManage/add', query: { titleId: this.titleId1, title: this.title } })
    } else {
      if (username === 'admin') {
        return
      }
      this.$router.push({ path: '/eventIntroductionManage/update', query: { id: st, titleId: this.titleId1, title: this.title } })
    }
  }

  //状态修改
  private statusHandle(row: any) {
    if (row.username === 'admin') {
      return
    }
    this.id = row.id
    this.status = row.status
    this.type = 1
    this.$confirm('确认调整该赛事介绍图的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisableAssembly({ id: this.id, status: !this.status ? 1 : 0 ,type: this.type})
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('赛事介绍图状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  // 删除
  private deleteHandle(type: string, id: any) {
    if (type === '批量' && id === null) {
      if (this.checkList.length === 0) {
        return this.$message.error('请选择删除对象')
      }
    }
    const params = {
      ids:type === '批量' ? this.checkList.join(',') : id
    }
    this.$confirm('确认删除该赛事规则, 是否继续?', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteAssembly(params)
        .then(res => {
          if (res && res.data && res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  // 全部操作
  private handleSelectionChange(val: any) {
    let checkArr: any[] = []
    val.forEach((n: any) => {
      checkArr.push(n.id)
    })
    this.checkList = checkArr
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }
}
